module.exports = __webpack_public_path__ + "img/6-narwhal_v8e.33f7c7f8.png";